module.exports = __webpack_public_path__ + "static/img/OBJECTSINSECTCARS.725e29f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OBJECTSINSECTCARS.svg
// module id = ZYnF
// module chunks = 3